import useAnalyticsEventTracker from "hooks/useAnalyticsEventTracker";
import "./styles.scss"
import { ReactComponent as User } from 'assets/icons/header/user.svg'




const LogBtn = ({ text }) => {

    return (
        <div className="log-btn-container">
            <button className="log-btn" onClick={useAnalyticsEventTracker({ category: "Navigation", action: "Login Click" })}>
                <User />
                {text}
            </button>
        </div>
    )
}






export default LogBtn;